export class UnsupportedFormatError extends Error {
  constructor(message: string, public format: string) {
    super(message);
    this.name = 'UnsupportedFormatError';
  }
}

export class FileTooLargeError extends Error {
  constructor(message: string, public maxBytes: number) {
    super(message);
    this.name = 'FileTooLargeError';
  }
}
